import { render, staticRenderFns } from "./urlIframe.vue?vue&type=template&id=c9d60fca&scoped=true&"
import script from "./urlIframe.vue?vue&type=script&lang=js&"
export * from "./urlIframe.vue?vue&type=script&lang=js&"
import style0 from "./urlIframe.vue?vue&type=style&index=0&id=c9d60fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d60fca",
  null
  
)

export default component.exports